var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "9px",
    viewBox: "0 0 6 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1F61B166-78C0-45C8-8214-020A763967C9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V0.1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(-43.000000, -25.000000)",
    fill: "#89231B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8099717,27.5702684 L49.4249333,27.1883418 C49.2915035,27.0627925 49.1356645,27 48.957776,27 C48.7762186,27 48.622232,27.0627925 48.4955645,27.1883418 L46.000018,29.6629822 L43.5044895,27.1884131 C43.3778399,27.0628638 43.2238174,27.0000713 43.0423319,27.0000713 C42.8643535,27.0000713 42.7085505,27.0628638 42.5751026,27.1884131 L42.195118,27.5703397 C42.0650154,27.6992595 42,27.8537529 42,28.0336772 C42,28.2169541 42.0650873,28.3696998 42.1951,28.4918785 L45.5378424,31.80654 C45.6611288,31.9354777 45.8150974,32 46,32 C46.1814315,32 46.3372166,31.9354955 46.4671933,31.80654 L49.8099537,28.4918785 C49.9366213,28.3662579 50,28.2135301 50,28.0336772 C50,27.8571057 49.9366393,27.7027014 49.8099717,27.5702684 Z",
    id: "Path",
    transform: "translate(46.000000, 29.500000) rotate(90.000000) translate(-46.000000, -29.500000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.eb5ace42201082ed44d95480ab6da1f4.svg";
export { ForwardRef as ReactComponent };